import { ProjectGq } from '../../../../../graphql/projects/models/ProjectGq';
import { ProjectTypeGq } from '../../../../../graphql/projects/models/ProjectTypeGq';
import { KeywordTableColumn, KeywordTableColumnTypes } from './models';

export const getColumnDescription = (
  column: KeywordTableColumn,
  project: ProjectGq
): string | undefined => {
  if (column.type === KeywordTableColumnTypes.Keyword) return undefined;
  if (column.type === KeywordTableColumnTypes.EnglishTranslation)
    return 'English translation of the keyword, if it has been translated in the project';
  if (column.type === KeywordTableColumnTypes.ArchiveTime)
    return 'The time when a keyword was archived';
  if (column.type === KeywordTableColumnTypes.RankStatus)
    return 'Status (and status date) for the rank data retrieval';
  if (column.type === KeywordTableColumnTypes.SerpFeatures)
    return 'Different features present on the Search Result Page, requires rank data';
  if (column.type === KeywordTableColumnTypes.SeedKeyword)
    return 'The seed which generated this keyword';
  if (column.type === KeywordTableColumnTypes.SeedType)
    return 'The type of seed which generated this keyword';
  if (column.type === KeywordTableColumnTypes.KeywordSearch)
    return "When keywords are added a 'keyword search' is created, usually named after the first keyword";
  if (column.type === KeywordTableColumnTypes.Volume)
    return 'Average monthly searches for a keyword (from Google Keyword Planner)';
  if (column.type === KeywordTableColumnTypes.VolumeTrend)
    return (`${'Comparing the average volume of the last 1-12 months to 13-24 months'}  ${project?.type !== ProjectTypeGq.QUICK_SEARCH ? ` (of project's calendar)` : ''}`);
  if (column.type === KeywordTableColumnTypes.VolumeMonthPeak)
    return (`${'The month(s) with the highest volume in the last 12-month-period'}  ${project?.type !== ProjectTypeGq.QUICK_SEARCH ? ` (of project's calendar)` : ''}`);
  if (column.type === KeywordTableColumnTypes.VolumeQuarterPeak)
    return (`${'The quarter(s) with the highest volume in the last 12-month-period'}  ${project?.type !== ProjectTypeGq.QUICK_SEARCH ? ` (of project's calendar)` : ''}`);
  if (column.type === KeywordTableColumnTypes.Cpc)
    return 'Average cost per click on Google ads (from Google Keyword Planner)';
  if (column.type === KeywordTableColumnTypes.CpcBidHigh)
    return '80th percentile on Google Ads bid cost (from Google Keyword Planner)';
  if (column.type === KeywordTableColumnTypes.CpcBidLow)
    return '20th percentile on Google Ads bid cost (from Google Keyword Planner)';
  if (column.type === KeywordTableColumnTypes.Competition)
    return 'Competition index 0-100: low [0-33], medium [34-66], high [67-100] (from Google Keyword Planner)';
  if (column.type === KeywordTableColumnTypes.TranslationFrom)
    return 'The original word, if the keyword has been translated';
  if (column.type === KeywordTableColumnTypes.TranslationFromVolume)
    return 'The original volume, if the keyword has been translated';
  if (column.type === KeywordTableColumnTypes.VolumeLast12months)
    return (`${'Average volume for each of the last 12 months'}  ${project?.type !== ProjectTypeGq.QUICK_SEARCH ? ` (of project's calendar)` : ''}`);
  if (column.type === KeywordTableColumnTypes.Rank) {
    return 'Domain position (requires rank data)';
  }

  if (column.type === KeywordTableColumnTypes.TagGroup) {
    return 'Tag group';
  }
  if (column.type === KeywordTableColumnTypes.TagCount) {
    return 'Total number of tags added to a keyword';
  }

  return '?';
};
